import {
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  Bookmark,
  Building2,
  Calendar,
  ChevronRight,
  ExternalLink,
  Heart,
  Info,
  MapPin,
  MessageCircle,
  Navigation,
  PawPrint,
  PenSquare,
  Phone,
  Play,
  Search,
  Share2,
  Shield,
  Sparkles,
} from 'lucide-react';

export const ICON_MAP = {
  AlertCircle,
  AlertTriangle,
  ArrowLeft,
  Bookmark,
  Building2,
  Calendar,
  ChevronRight,
  ExternalLink,
  Heart,
  Info,
  MapPin,
  MessageCircle,
  Navigation,
  PawPrint,
  PenSquare,
  Phone,
  Play,
  Search,
  Share2,
  Shield,
  Sparkles,
};

export function getIcon(name) {
  const Icon = ICON_MAP[name];
  if (!Icon) {
    if (process.env.NODE_ENV !== 'production') {
      // eslint-disable-next-line no-console
      console.warn(
        `[AISearch] Missing icon "${name}" in iconMap.js — falling back to AlertCircle.`
      );
    }
    return AlertCircle;
  }
  return Icon;
}
